'use client';

import { useLocation } from 'react-router';
import { use } from 'react';
import { OrganizationContext } from '@/lib/OrganizationContext';
import { hexToOklch, generateColorVariations } from '@/lib/colorUtils';

/**
 * Hook para manejar el tema de la organización
 * Detecta si estamos en una página pública y aplica el color de la organización
 */
export function useOrganizationTheme() {
  const location = useLocation();
  const pathname = location.pathname;
  const organizationContext = use(OrganizationContext);
  const currentOrganization = organizationContext?.currentOrganization || null;

  const isPublicRoute =
    pathname === '/' ||
    (pathname.startsWith('/tournaments/') && !pathname.startsWith('/tournaments/admin'));

  const shouldApplyOrganizationColor = !isPublicRoute && currentOrganization?.primary_color;

  const primaryColor =
    shouldApplyOrganizationColor && currentOrganization.primary_color
      ? hexToOklch(currentOrganization.primary_color)
      : 'oklch(0.64 0.24 14)';

  const colorVariations = generateColorVariations(primaryColor);

  return {
    isPublicRoute,
    shouldApplyOrganizationColor,
    primaryColor,
    colorVariations,
    organization: currentOrganization,
  };
}
